/**
 * @packageDocumentation
 * @module      Fetcher.ts
 * @description Mock-friendly pass-through module to JavaScript's fetch API.
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
/**
 * Mock-friendly pass-through module to JavaScript's fetch API.
 *
 * This is a low-tech, low-dependency alternative to NPM libraries such as fetch-mock. All those that I tried had
 * drawbacks such as incompatibility with ES modules, requirements to add unwanted parameters to tsconfig.json
 * or webpack.config.js, or outdated technology.
 */
export default class Fetcher {
    /** Pass the parameters to JavaScript's fetch function and return fetch's result. */
    fetch(input, init) {
        return fetch(input, init);
    }
}
//# sourceMappingURL=Fetcher.js.map